import { defineComponent as C, useTemplateRef as B, computed as y, createBlock as i, openBlock as a, unref as r, normalizeStyle as D, normalizeClass as F, withCtx as c, renderSlot as H, createElementBlock as f, createCommentVNode as g, createElementVNode as k, toDisplayString as v, Fragment as m, renderList as I, mergeProps as h, toHandlers as b, createVNode as p } from "vue";
import { RevList as w } from "@ds/components/List";
import { RevListItemStatic as L } from "@ds/components/ListItemStatic";
import { tw as s } from "../../../utils/tailwind.js";
import { isOptionsGroup as E } from "../InputSelectSearchable.helpers.js";
import x from "./InputSelectSearchableItem.vue2.js";
const N = { class: "text-static-default-low px-20" }, P = { class: "text-action-default-hi body-1-bold px-24" }, G = /* @__PURE__ */ C({
  __name: "InputSelectSearchableOptionsList",
  props: {
    view: {},
    noOptionsMessage: {},
    maxHeight: { default: "" },
    hide: { type: Function },
    hideCheckbox: { type: Boolean },
    isOptionSelected: { type: Function },
    options: {},
    listId: {},
    defaultOption: {},
    searchPlacement: {},
    getListItemListeners: { type: Function },
    flatOptionIndexes: {},
    activeOptionIndex: {}
  },
  setup(e) {
    const o = B("listbox");
    function u(l) {
      const d = e.flatOptionIndexes[l.id] === e.activeOptionIndex;
      return {
        id: l.id,
        hideCheckbox: e.hideCheckbox,
        isSelected: e.isOptionSelected(l),
        label: l.label,
        description: l?.description,
        suffix: l?.suffix,
        listboxElement: o.value?.$el,
        class: d ? s`bg-static-default-min-hover` : s`!bg-static-default-min`
      };
    }
    const O = y(() => e.searchPlacement === "dropdown"), S = y(() => {
      const l = s`rounded-sm overflow-y-auto`, d = s`bg-action-default-low shadow-long mt-4`, t = s`p-0`, n = s`[&>li:first-of-type]:!border-static-default-mid`;
      return [
        l,
        e.view === "desktop" ? d : t,
        e.view === "desktop" && O.value ? n : null
      ];
    });
    return (l, d) => (a(), i(r(w), {
      id: e.listId,
      ref_key: "listbox",
      ref: o,
      class: F(S.value),
      "has-external-borders": !1,
      role: "listbox",
      style: D({ maxHeight: e.maxHeight })
    }, {
      default: c(() => [
        H(l.$slots, "search"),
        e.options.length === 0 ? (a(), i(r(L), {
          key: 0,
          role: "presentation"
        }, {
          label: c(() => [
            k("span", N, v(e.noOptionsMessage), 1)
          ]),
          _: 1
        })) : o.value ? (a(!0), f(m, { key: 1 }, I(e.options, (t) => (a(), f(m, {
          key: t.id
        }, [
          r(E)(t) ? (a(), i(r(w), {
            key: 1,
            "aria-labelledby": t.id,
            "has-external-borders": !1,
            role: "group"
          }, {
            default: c(() => [
              p(r(L), {
                id: t.id,
                "aria-label": t.label,
                role: "presentation"
              }, {
                label: c(() => [
                  k("span", P, v(t.label), 1)
                ]),
                _: 2
              }, 1032, ["id", "aria-label"]),
              (a(!0), f(m, null, I(t.options, (n) => (a(), i(x, h({
                key: n.id
              }, { ref_for: !0 }, u(n), b(e.getListItemListeners(n, e.hide))), null, 16))), 128))
            ]),
            _: 2
          }, 1032, ["aria-labelledby"])) : (a(), i(x, h({
            key: 0,
            class: "border-static-default-low"
          }, { ref_for: !0 }, u(t), b(e.getListItemListeners(t, e.hide))), null, 16))
        ], 64))), 128)) : g("", !0),
        e.defaultOption && o.value ? (a(), i(x, h({ key: 2 }, u(e.defaultOption), b(e.getListItemListeners(e.defaultOption, e.hide))), null, 16)) : g("", !0)
      ]),
      _: 3
    }, 8, ["id", "class", "style"]));
  }
});
export {
  G as default
};
